export default "__VITE_ASSET__C8ZVkl1u__"